var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "vendor-bid-status-list",
      attrs: {
        title: _vm.$t("tender.healthcheck"),
        expand: false,
        withBorder: false,
      },
    },
    [_c("HealthCheck", { attrs: { slot: "content" }, slot: "content" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }